import { render } from "./FormSeparator.vue?vue&type=template&id=3b87686a"
import script from "./FormSeparator.vue?vue&type=script&lang=js"
export * from "./FormSeparator.vue?vue&type=script&lang=js"

import "./FormSeparator.vue?vue&type=style&index=0&id=3b87686a&lang=css"
script.render = render

export default script